import { useState } from 'react';
import { useScrollAnimation } from '@/hooks/useScrollAnimation';

const CITIES = [
  {
    id: 1,
    city: '北京',
    cityEn: 'Beijing',
    country: '中国',
    flag: '🇨🇳',
    members: '8.2万+',
    couples: '2.1万+',
    image: 'https://public.readdy.ai/ai/img_res/3a4ccb93c4ad004ea028acedb02947ae.jpg',
    highlight: '名校云集 · 精英汇聚',
    color: 'from-red-900/80 to-red-700/60',
  },
  {
    id: 2,
    city: '上海',
    cityEn: 'Shanghai',
    country: '中国',
    flag: '🇨🇳',
    members: '9.5万+',
    couples: '2.8万+',
    image: 'https://readdy.ai/api/search-image?query=romantic%20Chinese%20couple%20on%20the%20Bund%20Shanghai%2C%20Pudong%20skyline%20background%20at%20night%2C%20city%20lights%20reflection%2C%20elegant%20dress%2C%20happy%20together%2C%20cinematic%20photography%2C%20warm%20tones%2C%20love%20story%2C%20modern%20city%20romance&width=480&height=600&seq=city-shanghai-01&orientation=portrait',
    highlight: '国际都市 · 精英首选',
    color: 'from-rose-900/80 to-rose-700/60',
  },
  {
    id: 3,
    city: '香港',
    cityEn: 'Hong Kong',
    country: '中国香港',
    flag: '🇭🇰',
    members: '3.1万+',
    couples: '8,600+',
    image: 'https://readdy.ai/api/search-image?query=romantic%20Chinese%20couple%20at%20Victoria%20Harbour%20Hong%20Kong%2C%20stunning%20skyline%20background%2C%20evening%20golden%20hour%2C%20elegant%20fashion%2C%20happy%20smiling%2C%20cinematic%20photography%2C%20warm%20romantic%20atmosphere%2C%20city%20lights%2C%20love&width=480&height=600&seq=city-hk-01&orientation=portrait',
    highlight: '东西交融 · 国际视野',
    color: 'from-amber-900/80 to-amber-700/60',
  },
  {
    id: 4,
    city: '悉尼',
    cityEn: 'Sydney',
    country: '澳大利亚',
    flag: '🇦🇺',
    members: '1.8万+',
    couples: '4,200+',
    image: 'https://readdy.ai/api/search-image?query=romantic%20Chinese%20couple%20at%20Sydney%20Opera%20House%20Australia%2C%20beautiful%20harbour%20bridge%20background%2C%20sunny%20blue%20sky%2C%20casual%20elegant%20fashion%2C%20happy%20smiling%2C%20cinematic%20photography%2C%20warm%20natural%20light%2C%20love%20and%20happiness&width=480&height=600&seq=city-sydney-01&orientation=portrait',
    highlight: '海外华人 · 品质生活',
    color: 'from-teal-900/80 to-teal-700/60',
  },
  {
    id: 5,
    city: '迪拜',
    cityEn: 'Dubai',
    country: '阿联酋',
    flag: '🇦🇪',
    members: '6,800+',
    couples: '1,500+',
    image: 'https://readdy.ai/api/search-image?query=romantic%20Chinese%20couple%20in%20Dubai%20with%20Burj%20Khalifa%20skyscraper%20background%2C%20luxury%20modern%20architecture%2C%20golden%20sunset%20desert%20light%2C%20elegant%20fashion%2C%20happy%20smiling%2C%20cinematic%20photography%2C%20warm%20golden%20tones%2C%20love%20story&width=480&height=600&seq=city-dubai-01&orientation=portrait',
    highlight: '商业精英 · 财富汇聚',
    color: 'from-yellow-900/80 to-yellow-700/60',
  },
  {
    id: 6,
    city: '纽约',
    cityEn: 'New York',
    country: '美国',
    flag: '🇺🇸',
    members: '2.4万+',
    couples: '6,100+',
    image: 'https://readdy.ai/api/search-image?query=romantic%20Chinese%20couple%20in%20New%20York%20City%20Central%20Park%2C%20Manhattan%20skyline%20background%2C%20autumn%20leaves%2C%20elegant%20fashion%2C%20happy%20smiling%2C%20cinematic%20photography%2C%20warm%20golden%20hour%20light%2C%20love%20and%20romance%2C%20beautiful%20city&width=480&height=600&seq=city-newyork-01&orientation=portrait',
    highlight: '常青藤精英 · 海外华人',
    color: 'from-slate-900/80 to-slate-700/60',
  },
  {
    id: 7,
    city: '巴黎',
    cityEn: 'Paris',
    country: '法国',
    flag: '🇫🇷',
    members: '8,900+',
    couples: '2,100+',
    image: 'https://readdy.ai/api/search-image?query=romantic%20Chinese%20couple%20at%20Eiffel%20Tower%20Paris%20France%2C%20beautiful%20Parisian%20architecture%20background%2C%20golden%20sunset%20light%2C%20elegant%20fashion%2C%20happy%20smiling%2C%20cinematic%20photography%2C%20warm%20romantic%20atmosphere%2C%20love%20story%2C%20European%20charm&width=480&height=600&seq=city-paris-01&orientation=portrait',
    highlight: '艺术之都 · 浪漫情缘',
    color: 'from-pink-900/80 to-pink-700/60',
  },
  {
    id: 8,
    city: '伦敦',
    cityEn: 'London',
    country: '英国',
    flag: '🇬🇧',
    members: '1.5万+',
    couples: '3,800+',
    image: 'https://readdy.ai/api/search-image?query=romantic%20Chinese%20couple%20at%20Tower%20Bridge%20London%20England%2C%20Thames%20River%20background%2C%20beautiful%20British%20architecture%2C%20elegant%20fashion%2C%20happy%20smiling%2C%20cinematic%20photography%2C%20warm%20golden%20light%2C%20love%20and%20romance%2C%20classic%20European%20city&width=480&height=600&seq=city-london-01&orientation=portrait',
    highlight: '学术精英 · 英伦风情',
    color: 'from-indigo-900/80 to-indigo-700/60',
  },
  {
    id: 9,
    city: '新加坡',
    cityEn: 'Singapore',
    country: '新加坡',
    flag: '🇸🇬',
    members: '2.2万+',
    couples: '5,400+',
    image: 'https://readdy.ai/api/search-image?query=romantic%20Chinese%20couple%20at%20Marina%20Bay%20Sands%20Singapore%2C%20stunning%20city%20skyline%20background%2C%20evening%20golden%20hour%2C%20elegant%20fashion%2C%20happy%20smiling%2C%20cinematic%20photography%2C%20warm%20romantic%20atmosphere%2C%20modern%20luxury%20city%2C%20love&width=480&height=600&seq=city-singapore-01&orientation=portrait',
    highlight: '亚洲金融中心 · 华人聚集',
    color: 'from-emerald-900/80 to-emerald-700/60',
  },
  {
    id: 10,
    city: '广州',
    cityEn: 'Guangzhou',
    country: '中国',
    flag: '🇨🇳',
    members: '5.6万+',
    couples: '1.4万+',
    image: 'https://readdy.ai/api/search-image?query=romantic%20Chinese%20couple%20in%20Guangzhou%20Canton%20Tower%20background%2C%20Pearl%20River%20night%20view%2C%20city%20lights%20reflection%2C%20elegant%20fashion%2C%20happy%20smiling%2C%20cinematic%20photography%2C%20warm%20tones%2C%20love%20story%2C%20modern%20Chinese%20city&width=480&height=600&seq=city-guangzhou-01&orientation=portrait',
    highlight: '粤港澳大湾区 · 商业中心',
    color: 'from-orange-900/80 to-orange-700/60',
  },
  {
    id: 11,
    city: '成都',
    cityEn: 'Chengdu',
    country: '中国',
    flag: '🇨🇳',
    members: '4.1万+',
    couples: '1.1万+',
    image: 'https://readdy.ai/api/search-image?query=romantic%20Chinese%20couple%20in%20Chengdu%20Sichuan%2C%20traditional%20teahouse%20setting%2C%20beautiful%20Chinese%20garden%2C%20warm%20cozy%20atmosphere%2C%20elegant%20fashion%2C%20happy%20smiling%2C%20cinematic%20photography%2C%20warm%20golden%20tones%2C%20love%20story%2C%20cultural%20heritage&width=480&height=600&seq=city-chengdu-01&orientation=portrait',
    highlight: '天府之国 · 悠然生活',
    color: 'from-lime-900/80 to-lime-700/60',
  },
  {
    id: 12,
    city: '墨尔本',
    cityEn: 'Melbourne',
    country: '澳大利亚',
    flag: '🇦🇺',
    members: '1.2万+',
    couples: '2,900+',
    image: 'https://readdy.ai/api/search-image?query=romantic%20Chinese%20couple%20in%20Melbourne%20Australia%2C%20Federation%20Square%20background%2C%20beautiful%20city%20architecture%2C%20sunny%20day%2C%20elegant%20fashion%2C%20happy%20smiling%2C%20cinematic%20photography%2C%20warm%20natural%20light%2C%20love%20and%20happiness%2C%20multicultural%20city&width=480&height=600&seq=city-melbourne-01&orientation=portrait',
    highlight: '宜居之城 · 华人社区',
    color: 'from-violet-900/80 to-violet-700/60',
  },
];

export default function GlobalCities() {
  const [activeCity, setActiveCity] = useState<number | null>(null);
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section ref={ref} className="py-20 bg-gradient-to-br from-gray-950 via-gray-900 to-red-950 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 md:px-8">

        {/* Header */}
        <div
          className="text-center mb-14 transition-all duration-700"
          style={{ opacity: isVisible ? 1 : 0, transform: isVisible ? 'translateY(0)' : 'translateY(30px)' }}
        >
          <div className="inline-flex items-center gap-2 bg-white/10 border border-white/20 rounded-full px-5 py-2 mb-5">
            <i className="ri-global-line text-yellow-400"></i>
            <span className="text-sm font-bold text-white">全球华人婚恋 · 800大城市</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" style={{ fontFamily: "'Noto Serif SC', serif" }}>
            无论您在哪里<br />
            <span className="text-yellow-300">缘分都在等您</span>
          </h2>
          <p className="text-white/60 text-base max-w-2xl mx-auto leading-relaxed">
            富缘佳旺覆盖全球800大城市华人社区，从北京到纽约，从香港到巴黎，每一座城市都有真实认证的优质会员等待与您相遇。
          </p>
        </div>

        {/* City Grid — 12 photos */}
        <div
          className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-3 mb-12 transition-all duration-700"
          style={{ opacity: isVisible ? 1 : 0, transform: isVisible ? 'translateY(0)' : 'translateY(40px)', transitionDelay: '200ms' }}
        >
          {CITIES.map((city, i) => (
            <div
              key={city.id}
              onMouseEnter={() => setActiveCity(city.id)}
              onMouseLeave={() => setActiveCity(null)}
              className="relative rounded-2xl overflow-hidden cursor-pointer group transition-all duration-500"
              style={{
                height: i < 2 ? '340px' : i < 6 ? '280px' : '240px',
                transitionDelay: `${i * 50}ms`,
              }}
            >
              <img
                src={city.image}
                alt={`${city.city} couples`}
                className="absolute inset-0 w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-700"
              />
              {/* Gradient overlay */}
              <div className={`absolute inset-0 bg-gradient-to-t ${city.color} group-hover:opacity-90 transition-opacity duration-300`}></div>

              {/* City Info */}
              <div className="absolute inset-0 flex flex-col justify-end p-3">
                <div className="flex items-center gap-1.5 mb-1">
                  <span className="text-base">{city.flag}</span>
                  <span className="text-white font-bold text-sm">{city.city}</span>
                </div>
                <div className="text-white/70 text-xs mb-2">{city.cityEn} · {city.country}</div>

                {/* Stats - show on hover */}
                <div className={`transition-all duration-300 overflow-hidden ${activeCity === city.id ? 'max-h-24 opacity-100' : 'max-h-0 opacity-0'}`}>
                  <div className="text-white/80 text-xs mb-1">{city.highlight}</div>
                  <div className="flex gap-2">
                    <div className="bg-white/20 rounded-lg px-2 py-1 text-center">
                      <div className="text-white font-bold text-xs">{city.members}</div>
                      <div className="text-white/60 text-[10px]">会员</div>
                    </div>
                    <div className="bg-red-500/40 rounded-lg px-2 py-1 text-center">
                      <div className="text-white font-bold text-xs">{city.couples}</div>
                      <div className="text-white/60 text-[10px]">牵手</div>
                    </div>
                  </div>
                </div>

                {/* Always visible member count */}
                {activeCity !== city.id && (
                  <div className="flex items-center gap-1">
                    <i className="ri-user-heart-line text-red-300 text-xs"></i>
                    <span className="text-white/70 text-xs">{city.members} 会员</span>
                  </div>
                )}
              </div>

              {/* Top badge */}
              {i < 3 && (
                <div className="absolute top-3 left-3 bg-red-600/90 text-white text-xs px-2 py-0.5 rounded-full font-semibold">
                  热门
                </div>
              )}
            </div>
          ))}
        </div>

        {/* City Stats Bar */}
        <div
          className="bg-white/5 border border-white/10 rounded-2xl p-6 transition-all duration-700"
          style={{ opacity: isVisible ? 1 : 0, transform: isVisible ? 'translateY(0)' : 'translateY(20px)', transitionDelay: '400ms' }}
        >
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
            {[
              { icon: 'ri-global-line', num: '800', label: '覆盖城市', sub: '横跨6大洲' },
              { icon: 'ri-user-heart-line', num: '600万+', label: '全球认证会员', sub: '持续增长中' },
              { icon: 'ri-heart-2-line', num: '280万+', label: '成功牵手', sub: '真实婚恋故事' },
              { icon: 'ri-map-2-line', num: '15+', label: '国家和地区', sub: '全球华人社区' },
            ].map((stat, i) => (
              <div key={i} className="flex flex-col items-center gap-2">
                <div className="w-10 h-10 flex items-center justify-center bg-red-600/20 rounded-xl">
                  <i className={`${stat.icon} text-red-400 text-lg`}></i>
                </div>
                <div className="text-2xl font-bold text-white">{stat.num}</div>
                <div className="text-white/80 text-sm font-medium">{stat.label}</div>
                <div className="text-white/40 text-xs">{stat.sub}</div>
              </div>
            ))}
          </div>
        </div>

        {/* City Filter Tabs */}
        <div
          className="mt-10 transition-all duration-700"
          style={{ opacity: isVisible ? 1 : 0, transitionDelay: '500ms' }}
        >
          <p className="text-white/50 text-xs text-center mb-4">按城市筛选会员</p>
          <div className="flex flex-wrap gap-2 justify-center">
            {CITIES.map((city) => (
              <button
                key={city.id}
                className="flex items-center gap-1.5 bg-white/10 hover:bg-red-600/40 border border-white/10 hover:border-red-500/50 text-white/70 hover:text-white rounded-full px-4 py-2 text-xs font-medium transition-all cursor-pointer whitespace-nowrap"
              >
                <span>{city.flag}</span>
                <span>{city.city}</span>
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
